import * as Types from '../../../../../__generated__/types.gqlgenerated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetJobSeekerProfileUploadResumeUrlMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type GetJobSeekerProfileUploadResumeUrlMutation = { __typename?: 'Mutation', createJobSeekerProfileUploadResumeFileTempUrl?: { __typename?: 'CreateJobSeekerProfileUploadResumeFileTempUrlPayload', uploadURL: string, fileId: string } | null };


export const GetJobSeekerProfileUploadResumeUrlDocument = gql`
    mutation GetJobSeekerProfileUploadResumeURL {
  createJobSeekerProfileUploadResumeFileTempUrl {
    uploadURL
    fileId
  }
}
    `;
export type GetJobSeekerProfileUploadResumeUrlMutationFn = Apollo.MutationFunction<GetJobSeekerProfileUploadResumeUrlMutation, GetJobSeekerProfileUploadResumeUrlMutationVariables>;

/**
 * __useGetJobSeekerProfileUploadResumeUrlMutation__
 *
 * To run a mutation, you first call `useGetJobSeekerProfileUploadResumeUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetJobSeekerProfileUploadResumeUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getJobSeekerProfileUploadResumeUrlMutation, { data, loading, error }] = useGetJobSeekerProfileUploadResumeUrlMutation({
 *   variables: {
 *   },
 * });
 */
export function useGetJobSeekerProfileUploadResumeUrlMutation(baseOptions?: Apollo.MutationHookOptions<GetJobSeekerProfileUploadResumeUrlMutation, GetJobSeekerProfileUploadResumeUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetJobSeekerProfileUploadResumeUrlMutation, GetJobSeekerProfileUploadResumeUrlMutationVariables>(GetJobSeekerProfileUploadResumeUrlDocument, options);
      }
export type GetJobSeekerProfileUploadResumeUrlMutationHookResult = ReturnType<typeof useGetJobSeekerProfileUploadResumeUrlMutation>;
export type GetJobSeekerProfileUploadResumeUrlMutationResult = Apollo.MutationResult<GetJobSeekerProfileUploadResumeUrlMutation>;
export type GetJobSeekerProfileUploadResumeUrlMutationOptions = Apollo.BaseMutationOptions<GetJobSeekerProfileUploadResumeUrlMutation, GetJobSeekerProfileUploadResumeUrlMutationVariables>;